export const INFO : IUSPs = {
    type: 'normal',
    uSPsList: [],
}
